import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  { path: "/not-authorized", name: "notAuthorized", component: () => import("../views/NotAuthorizedView.vue") },
  { path: "/", name: "splashView", component: () => import("../views/SplashView.vue") },
  { path: "/clock-in", name: "clockIn", props: true, component: () => import("../views/ClockIn.vue") },
  { path: "/home/:id?", name: "home", component: () => import("../views/HomeView.vue") },
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL || "/",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === "/" && from.name === "home") {
    return next(false);
  }

  return next();
});

export default router;